<template>
	<div class="h-60">

		<div class="block w-full">
			<div class="groupTitle">
        {{ $t('popups.providerManagement.gsmSearch') }}
      </div>
			<div class="grid grid-cols-2 gap-4 w-full">
				<div>
					<div class="inputTitle">
						{{ $t('popups.providerManagementDetails.dialCode') }} *
					</div>
					<div class="inputField flex-grow">
						<div :class="{ error: v$.dialCode.$errors.length }">
							<Select :options="countryDialCodes" class="w-full" mode="single" @selectChanged="(value)=>{popupData.dialCode = countryDialCodes.find(cc => cc.id === value)?.dialCode}" />
							<div class="input-errors" v-for="error of v$.dialCode.$errors" :key="error.$uid">
								<div class="error-msg">{{ error.$message }}</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="inputTitle">
						{{ $t('popups.providerManagementDetails.phoneNumber') }} *
					</div>
					<div class="inputField flex-grow">
						<div :class="{ error: v$.phoneNumber.$errors.length }">
							<input type="text" v-model="popupData.phoneNumber" class="w-full" :placeholder="phoneNumberPlaceholder.replace('+49','')" /><br />
							<div class="input-errors" v-for="error of v$.phoneNumber.$errors" :key="error.$uid">
								<div class="error-msg">{{ error.$message }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="contextError errorType rounded mt-4 text-sm" v-if="popupData.userInfo !== ''">
					{{popupData.userInfo}}
				</div>
				<h4 v-if="!popupData.showUserInfo">
					{{ $t('providerManagementDetails.find') }}
					<span class="gridTooltipButton tooltip infoIcon ">
						<span class="icon-info "></span>
						<span class=" tooltiptext shadow ">
							<b>{{ $t('providerManagementDetails.infoTitle') }}</b><br />

							{{ $t('providerManagementDetails.infoText') }}
						</span>
					</span>
				</h4>
				<div v-if="popupData.showUserInfo" class="col-span-2 mt-4 p-4 border rounded">
					<div>
						<strong>{{ $t('providerManagement.grid.companyName') }}:</strong>
						<router-link :to="`/providermanagement/${popupData.companyId}`" class="text-blue-600 underline">
							{{ popupData.companyName }}
						</router-link>
					</div>
					<div><strong>{{ $t('popups.providerManagementDetails.username') }}:</strong> {{ popupData.fullName }}</div>
					<div><strong>{{ $t('providerManagementDetails.grid.email') }}:</strong> {{ popupData.email }}</div>
					<div><strong>{{ $t('providerManagementDetails.grid.phoneNumber') }}:</strong> {{ popupData.dialCode }} {{ popupData.phoneNumber }}</div>
				</div>

			</div>
		</div>

	</div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, toRef} from "vue";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import Select from "@/components/inputs/Select";
import {countryDialCodes} from "@/AppConfig";
import {phoneNumberPlaceholder} from "@/AppConfig";
import { watch } from "vue";

const globalStore = useGlobalStore();
const { t } = useI18n();

const props = defineProps({
    data: Object
})

const popupData = toRef(props, 'data');

onMounted(async () => {
	globalStore.modal.validator = v$;
})
    watch(
        () => [popupData.value.dialCode, popupData.value.phoneNumber],
        ([newDial, newPhone], [oldDial, oldPhone]) => {
            if (newDial !== oldDial || newPhone !== oldPhone) {
                popupData.value.showUserInfo = false;
            }
        }
    );
// Validation

const rules = computed(() => {
	const rules = {
    dialCode: { required: helpers.withMessage(t('validators.required'), required) },
		phoneNumber: { required: helpers.withMessage(t('validators.required'), required) },
	}
	return rules
})

const v$ = ref(useVuelidate(rules, popupData))
</script>

<style scoped>

</style>
